export const MAIN_SETTINGS_COMPONENT: StatusOfComponent = {name: 'main-settings-component', visible: false};
export const GENERAL_SETTINGS_COMPONENT: StatusOfComponent = {name: 'general-settings-component', visible: false};
export const DASHBOARD_SETTINGS_COMPONENT: StatusOfComponent = {name: 'dashboard-settings-component', visible: false};
export const VIEW_SETTINGS_COMPONENT: StatusOfComponent = {name: 'view-settings-component', visible: false};
export const FORM_SETTINGS_COMPONENT: StatusOfComponent = {name: 'form-settings-component', visible: false};


interface StatusOfComponent {
    name: string;
    visible: boolean;
}
